export default __webpack_public_path__ + "static/media/Dokumentation.9a7c5002.png";